import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, AlertController, ToastController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { ConfigurationServices } from '../../configuration/services';
import { OrdersCoServices } from '../services';
import { OrdersSelectPage } from '../orders-select/orders-select';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsServices } from '../../services/analyticsServices';

/**
 * Generated class for the TpvLoaderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-orders-updel',
  templateUrl: 'orders-updel.html',
})
export class OrdersUpDelPage {

  update: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public ordersCoServices: OrdersCoServices,
    public globals: Globals,
    public loadingCtrl: LoadingController,
    public configurationServices: ConfigurationServices,
    public alertCtrl: AlertController,
    public translate: TranslateService,
    public toastCtrl: ToastController,
    public analyticsServices: AnalyticsServices) {

    this.ordersCoServices.getOrders(this.globals.restaurant_uid, this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].UID);
    this.update = this.navParams.get('update');
  }

  openModElement(i, j, element) {
    const confirm = this.alertCtrl.create({
      title: this.translate.instant('instant-seleccionar-plato-producto'),
      message: this.translate.instant('instant-modificar-plato-producto-seleccionado'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          handler: () => {

          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.openModSelect(i, j, element);
          }
        }
      ]
    });
    confirm.present();
  }

  openDelElement(i, j, element) {
    const confirm = this.alertCtrl.create({
      title: this.translate.instant('instant-seleccionar-plato-producto'),
      message: this.translate.instant('instant-elminar-plato-producto-seleccionado'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          handler: () => {

          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.deleteElement(i, j, element);
          }
        }
      ]
    });
    confirm.present();
  }

  openModSelect(i, j, element) {
    if (element.sections[i].list[j].type == 'combo' || element.sections[i].list[j].uid_element_combo != '') {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-no-puedes-editar-combo'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
    } else {

      this.ordersCoServices.i = i;
      this.ordersCoServices.j = j;
      this.ordersCoServices.element = element;
      this.ordersCoServices.update_state = true;
      this.navCtrl.push(OrdersSelectPage);
    }
  }

  deleteElement(i, j, element) {
    element.sections[i].list[j].state = 'delete';
    element.sections[i].list[j].finish = '';
    this.ordersCoServices.afs.collection('orders').doc(element.UID).update({
      sections: element.sections,
    }).then(async doc => {
      if (element.sections[i].list[j].change != '') {
        this.deleteFromTPV(element.sections[i].list[j].change);
      } else {
        this.deleteFromTPV(element.sections[i].list[j].name);
      }

    });
  }

  one_time: boolean = true;
  deleteFromTPV(name) {
    this.ordersCoServices.table_tmp = this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index];

    for (let list of this.globals.objectToArray(this.ordersCoServices.table_tmp.ticket.list)) {
      if (list.name == name && this.one_time && list.delete == false && list.count == true) {
        list.count = false;
        list.delete = true;
        this.one_time = false;
      }
    }

    this.ordersCoServices.afs.collection('tables').doc(this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].UID).update({
      ticket: {
        amount: this.ordersCoServices.table_tmp.ticket.amount,
        payment: this.ordersCoServices.table_tmp.ticket.payment,
        payment_type: this.ordersCoServices.table_tmp.ticket.payment_type,
        date: this.ordersCoServices.table_tmp.ticket.date,
        number: this.ordersCoServices.table_tmp.ticket.number,
        waiter: this.ordersCoServices.table_tmp.ticket.waiter,
        waiter_uid: this.ordersCoServices.table_tmp.ticket.waiter_uid,
        list: this.ordersCoServices.table_tmp.ticket.list,
        updated_at: new Date(),
        created_at: this.ordersCoServices.table_tmp.ticket.created_at,
        tip: this.ordersCoServices.table_tmp.ticket.tip || 0,
      },
      state: 'close'
    }).then(async doc => {
      //data set waiter activity
      var extra_activity: any =
      {
        'type': 'cancel',
        'value': 1,
        'source': 'orders',

      };
      this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');
      this.navCtrl.pop();
    });


  }

}



// WEBPACK FOOTER //
// ./src/pages/orders/orders-updel/orders-updel.ts